import { defineStore } from "pinia";
import { RouteLocationNormalizedLoaded } from 'vue-router'
import screenfull from 'screenfull'
import { ElMessage } from "element-plus"
export const useTabsStore = defineStore('tabs', {
    state: () => {
        return {
            tabsList: new Array<IbaseRoute>(),
            is_fullScroll: false,
            menuList: []
        }
    },
    actions: {
        fullScroll() {
            if (screenfull.isEnabled) {
                screenfull.toggle()
                
            } else {
                ElMessage("该浏览器不支持全屏！")
            }

        },
        addTabs(route: RouteLocationNormalizedLoaded): void {
            const baseroute: IbaseRoute = Object.assign({}, route)
            const arr = [...this.tabsList]
            let canadd: boolean = true
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].path === baseroute.path) {
                    canadd = false
                    break;
                }
            }
            canadd && this.tabsList.push(baseroute)
        },
        removeTabs(index: number): void {
            this.tabsList.splice(index, 1)
        }
    }
})


export interface ItabStore {
    tabsList: Array<IbaseRoute>,
    addTabs: Function,
    removeTabs: Function
}


export interface IbaseRoute {
    fullPath: string,
    path: string,
    [name: string]: any
}
